module.exports = __webpack_public_path__ + "img/450-2ebbbf.png";